module.exports = __webpack_public_path__ + "img/venue-overview-bg-2.e8b59f13.jpg";